import { Accordion } from "react-bootstrap"

export default function ConcursoPublico() {
    return <div>
    <p><small>Você está em <a href="/pessoal">Gestão de Pessoas</a> / Concurso Público</small></p>
    <Accordion defaultActiveKey="0" className='mb-5'>
    <Accordion.Item eventKey="0">
        <Accordion.Header>Informações</Accordion.Header>
        <Accordion.Body>
        <ul class="marcador">
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/editalresultadofinal.pdf" target="_blank" rel="noopener noreferrer">Edital de Divulgação do Resultado Final, publicado no Diário Oficial de 01/07/2014</a></li> 
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/aprovados.pdf" target="_blank" rel="noopener noreferrer">Relação de aprovados, publicada no Diário Oficial de 30/05/2014</a></li>
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/retificacaoconvocacao.pdf" target="_blank" rel="noopener noreferrer">Retificação do Edital N° 02/2014 de convocação para as provas</a></li>
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/editalconvocacao.pdf" target="_blank" rel="noopener noreferrer">Edital N° 02/2014 de convocação para as provas</a></li>
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/estatdeficiencia.pdf" target="_blank" rel="noopener noreferrer">Estatística de Candidatos com Deficiência</a></li>
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/concorrencia.pdf" target="_blank" rel="noopener noreferrer">Estatística Geral de Inscritos</a></li>
            <li><a href="http://www.alepe.pe.gov.br/downloads/concurso/edital.pdf" target="_blank" rel="noopener noreferrer">Edital N° 01/2014 de abertura de inscrições</a></li>
        </ul>
        </Accordion.Body>
    </Accordion.Item>
    <Accordion.Item eventKey="1">
        <Accordion.Header>Cargos</Accordion.Header>
        <Accordion.Body>
        <ul class="marcador">
            <li>AGENTE LEGISLATIVO (Ensino Médio Completo)</li>
            <li>ANALISTA LEGISLATIVO (Ensino Superior Completo): 
            <ul>
                <li>Comunicação Social - Área Mídia Impressa </li>
                <li>Comunicação Social - Área Rádio</li> 
                <li>Comunicação Social - Área Mídias Digitais</li> 
                <li>Comunicação Social - Área TV </li>
                <li>Consultoria Legislativa - Área Direito Constitucional, Administrativo e Eleitoral </li>
                <li>Consultoria Legislativa - Área Direito Tributário, Financeiro e Cidadania </li>
                <li>Consultoria Legislativa - Área Orçamento Público e Desenvolvimento Econômico </li>
                <li>Consultoria Legislativa - Área Administração e Políticas Públicas </li>
                <li>Consultoria Legislativa - Área Educação, Cultura e Desporto </li>
                <li>Consultoria Legislativa - Área Agricultura e Meio Ambiente </li>
                <li>Consultoria Legislativa - Área Redação e Pronunciamento </li>
                <li>Contabilidade</li> 
                <li>Informática - Área Infraestrutura </li>
                <li>Informática - Área Sistemas </li>
                <li>Engenharia </li>
                <li>Biblioteconomia </li>
            </ul>
            </li>
        </ul>
        </Accordion.Body>
    </Accordion.Item>
    <Accordion.Item eventKey="2">
        <Accordion.Header>Remuneração</Accordion.Header>
        <Accordion.Body>
        <ul class="marcador">
            <li>AGENTE LEGISLATIVO
                <ul>
                <li>R$ 4.780,74 (quatro mil setecentos e oitenta reais e setenta e quatro centavos)</li>
                </ul>
            </li>
            <li>ANALISTA LEGISLATIVO
                <ul>
                <li>R$ 11.315,33 (onze mil, trezentos e quinze reais e trinta e três centavos)</li>
                </ul>
            </li>
        </ul>
        </Accordion.Body>
    </Accordion.Item>
    <Accordion.Item eventKey="3">
        <Accordion.Header>Inscrições</Accordion.Header>
        <Accordion.Body>
        <ul class="marcador">
            <li>Ensino Superior Completo:
                <ul>
                <li>Valor da Inscrição: R$ 123,80 (cento e vinte e três reais e oitenta centavos)</li>
                </ul>
            </li>
            <li>Ensino Médio Completo: 
                <ul>
                <li>Valor da Inscrição: R$ 83,80 (oitenta e três reais e oitenta centavos)</li>
                </ul>
            </li>
        </ul>
        </Accordion.Body>
    </Accordion.Item>
    <Accordion.Item eventKey="4">
        <Accordion.Header>Provas</Accordion.Header>
        <Accordion.Body>
        <ul class="marcador">
            <li>Data provável da publicação do resultado das provas: 30/05/2014</li>
            <li>Data provável de realização das provas:<br/>
                Analista Legislativo: 06/04/2014 <br/>
                Agente Legislativo: 13/04/2014 </li>
        </ul>
        </Accordion.Body>
    </Accordion.Item>
</Accordion></div>
}